module.exports = {
	"config": {
		"siteTitle": "Golden City",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "alleyesonus.md",
				"ext": "md",
				"name": "alleyesonus",
				"extname": ".md",
				"basename": "alleyesonus.md",
				"dirname": "",
				"stem": "alleyesonus",
				"path": "alleyesonus.md"
			},
			"requirePath": "alleyesonus.md",
			"path": "/alleyesonus/",
			"data": {
				"title": "All Eyes On Us",
				"headImage": "ALLEYESONUS2"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "alleyesonus.sidebar.md",
				"ext": "md",
				"name": "alleyesonus.sidebar",
				"extname": ".md",
				"basename": "alleyesonus.sidebar.md",
				"dirname": "",
				"stem": "alleyesonus.sidebar",
				"path": "alleyesonus.sidebar.md"
			},
			"requirePath": "alleyesonus.sidebar.md",
			"path": "/alleyesonus.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "foerdermitglied.md",
				"ext": "md",
				"name": "foerdermitglied",
				"extname": ".md",
				"basename": "foerdermitglied.md",
				"dirname": "",
				"stem": "foerdermitglied",
				"path": "foerdermitglied.md"
			},
			"requirePath": "foerdermitglied.md",
			"path": "/foerdermitglied/",
			"data": {
				"title": "Ja ich will",
				"headImage": "foerdermitglied"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "foerdermitglied.sidebar.md",
				"ext": "md",
				"name": "foerdermitglied.sidebar",
				"extname": ".md",
				"basename": "foerdermitglied.sidebar.md",
				"dirname": "",
				"stem": "foerdermitglied.sidebar",
				"path": "foerdermitglied.sidebar.md"
			},
			"requirePath": "foerdermitglied.sidebar.md",
			"path": "/foerdermitglied.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "impressum.md",
				"ext": "md",
				"name": "impressum",
				"extname": ".md",
				"basename": "impressum.md",
				"dirname": "",
				"stem": "impressum",
				"path": "impressum.md"
			},
			"requirePath": "impressum.md",
			"path": "/impressum/",
			"data": {
				"title": "Impressum",
				"headImage": "Impressum"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "impressum.sidebar.md",
				"ext": "md",
				"name": "impressum.sidebar",
				"extname": ".md",
				"basename": "impressum.sidebar.md",
				"dirname": "",
				"stem": "impressum.sidebar",
				"path": "impressum.sidebar.md"
			},
			"requirePath": "impressum.sidebar.md",
			"path": "/impressum.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md"
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {
				"title": "Liebe Golden City-Fans,",
				"headImage": "wasistgoldencity"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.sidebar.md",
				"ext": "md",
				"name": "index.sidebar",
				"extname": ".md",
				"basename": "index.sidebar.md",
				"dirname": "",
				"stem": "index.sidebar",
				"path": "index.sidebar.md"
			},
			"requirePath": "index.sidebar.md",
			"path": "/index.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "lokalrunde.md",
				"ext": "md",
				"name": "lokalrunde",
				"extname": ".md",
				"basename": "lokalrunde.md",
				"dirname": "",
				"stem": "lokalrunde",
				"path": "lokalrunde.md"
			},
			"requirePath": "lokalrunde.md",
			"path": "/lokalrunde/",
			"data": {
				"title": "Die Golden City Lokalrunde",
				"headImage": "lokalrunde"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "lokalrunde.sidebar.md",
				"ext": "md",
				"name": "lokalrunde.sidebar",
				"extname": ".md",
				"basename": "lokalrunde.sidebar.md",
				"dirname": "",
				"stem": "lokalrunde.sidebar",
				"path": "lokalrunde.sidebar.md"
			},
			"requirePath": "lokalrunde.sidebar.md",
			"path": "/lokalrunde.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "programm",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "programm",
				"stem": "_template",
				"path": "programm/_template.js"
			},
			"requirePath": "programm/_template.js",
			"templatePath": "/programm/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "programm",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "programm",
				"stem": "index",
				"path": "programm/index.js"
			},
			"requirePath": "programm/index.js",
			"path": "/programm/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "alleyesonus.md",
				"ext": "md",
				"name": "alleyesonus",
				"extname": ".md",
				"basename": "alleyesonus.md",
				"dirname": "projekte",
				"stem": "alleyesonus",
				"path": "projekte/alleyesonus.md"
			},
			"requirePath": "projekte/alleyesonus.md",
			"path": "/projekte/alleyesonus/",
			"data": {
				"title": "All Eyes on Us",
				"headImage": "alleyesonus_haupt",
				"category": "theater",
				"order": 1
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "alleyesonus.sidebar.md",
				"ext": "md",
				"name": "alleyesonus.sidebar",
				"extname": ".md",
				"basename": "alleyesonus.sidebar.md",
				"dirname": "projekte",
				"stem": "alleyesonus.sidebar",
				"path": "projekte/alleyesonus.sidebar.md"
			},
			"requirePath": "projekte/alleyesonus.sidebar.md",
			"path": "/projekte/alleyesonus.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "festival.md",
				"ext": "md",
				"name": "festival",
				"extname": ".md",
				"basename": "festival.md",
				"dirname": "projekte",
				"stem": "festival",
				"path": "projekte/festival.md"
			},
			"requirePath": "projekte/festival.md",
			"path": "/projekte/festival/",
			"data": {
				"title": "Golden-City-360-Grad-Heimatliebe-Sommerfestival",
				"headImage": "festival",
				"category": "festival",
				"order": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "festival.sidebar.md",
				"ext": "md",
				"name": "festival.sidebar",
				"extname": ".md",
				"basename": "festival.sidebar.md",
				"dirname": "projekte",
				"stem": "festival.sidebar",
				"path": "projekte/festival.sidebar.md"
			},
			"requirePath": "projekte/festival.sidebar.md",
			"path": "/projekte/festival.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "projekte",
				"stem": "index",
				"path": "projekte/index.js"
			},
			"requirePath": "projekte/index.js",
			"path": "/projekte/",
			"data": {
				"headImage": "01GoldenCityHafenbar"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "kanali.md",
				"ext": "md",
				"name": "kanali",
				"extname": ".md",
				"basename": "kanali.md",
				"dirname": "projekte",
				"stem": "kanali",
				"path": "projekte/kanali.md"
			},
			"requirePath": "projekte/kanali.md",
			"path": "/projekte/kanali/",
			"data": {
				"title": "Mystirio Kanali",
				"headImage": "mystirio",
				"category": "mystiriokanali",
				"youtube": "N52ArBuET7E",
				"order": 6
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "kanali.sidebar.md",
				"ext": "md",
				"name": "kanali.sidebar",
				"extname": ".md",
				"basename": "kanali.sidebar.md",
				"dirname": "projekte",
				"stem": "kanali.sidebar",
				"path": "projekte/kanali.sidebar.md"
			},
			"requirePath": "projekte/kanali.sidebar.md",
			"path": "/projekte/kanali.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "lankenau.md",
				"ext": "md",
				"name": "lankenau",
				"extname": ".md",
				"basename": "lankenau.md",
				"dirname": "projekte",
				"stem": "lankenau",
				"path": "projekte/lankenau.md"
			},
			"requirePath": "projekte/lankenau.md",
			"path": "/projekte/lankenau/",
			"data": {
				"title": "Golden City Hafenbar im Lankenauer Höft",
				"headImage": "Lankenau2",
				"category": "lankenau",
				"order": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "lankenau.sidebar.md",
				"ext": "md",
				"name": "lankenau.sidebar",
				"extname": ".md",
				"basename": "lankenau.sidebar.md",
				"dirname": "projekte",
				"stem": "lankenau.sidebar",
				"path": "projekte/lankenau.sidebar.md"
			},
			"requirePath": "projekte/lankenau.sidebar.md",
			"path": "/projekte/lankenau.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "lokalrunde.md",
				"ext": "md",
				"name": "lokalrunde",
				"extname": ".md",
				"basename": "lokalrunde.md",
				"dirname": "projekte",
				"stem": "lokalrunde",
				"path": "projekte/lokalrunde.md"
			},
			"requirePath": "projekte/lokalrunde.md",
			"path": "/projekte/lokalrunde/",
			"data": {
				"title": "DIE GOLDEN CITY – LOKALRUNDE",
				"headImage": "lokalrunde",
				"category": "lokalrunde",
				"order": 4,
				"youtubeList": "PLSiRO8PBO2GyQMfyT21An5Lpa-EnHwRT6"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "lokalrunde.sidebar.md",
				"ext": "md",
				"name": "lokalrunde.sidebar",
				"extname": ".md",
				"basename": "lokalrunde.sidebar.md",
				"dirname": "projekte",
				"stem": "lokalrunde.sidebar",
				"path": "projekte/lokalrunde.sidebar.md"
			},
			"requirePath": "projekte/lokalrunde.sidebar.md",
			"path": "/projekte/lokalrunde.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "mythos.md",
				"ext": "md",
				"name": "mythos",
				"extname": ".md",
				"basename": "mythos.md",
				"dirname": "projekte",
				"stem": "mythos",
				"path": "projekte/mythos.md"
			},
			"requirePath": "projekte/mythos.md",
			"path": "/projekte/mythos/",
			"data": {
				"title": "Mythos Golden City – Wie alles begann...",
				"formattedTitle": "Mythos Golden City – <br />Wie alles begann...",
				"headImage": "mythosgoldencity",
				"category": "mythos",
				"order": 7
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "mythos.sidebar.md",
				"ext": "md",
				"name": "mythos.sidebar",
				"extname": ".md",
				"basename": "mythos.sidebar.md",
				"dirname": "projekte",
				"stem": "mythos.sidebar",
				"path": "projekte/mythos.sidebar.md"
			},
			"requirePath": "projekte/mythos.sidebar.md",
			"path": "/projekte/mythos.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "quarantaene.md",
				"ext": "md",
				"name": "quarantaene",
				"extname": ".md",
				"basename": "quarantaene.md",
				"dirname": "projekte",
				"stem": "quarantaene",
				"path": "projekte/quarantaene.md"
			},
			"requirePath": "projekte/quarantaene.md",
			"path": "/projekte/quarantaene/",
			"data": {
				"title": "DAS GOLDEN CITY QUARANTÄNEORCHESTER #1",
				"headImage": "quarantaene",
				"category": "quarantaene",
				"order": 3
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "quarantaene.sidebar.md",
				"ext": "md",
				"name": "quarantaene.sidebar",
				"extname": ".md",
				"basename": "quarantaene.sidebar.md",
				"dirname": "projekte",
				"stem": "quarantaene.sidebar",
				"path": "projekte/quarantaene.sidebar.md"
			},
			"requirePath": "projekte/quarantaene.sidebar.md",
			"path": "/projekte/quarantaene.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "sehnsucht.md",
				"ext": "md",
				"name": "sehnsucht",
				"extname": ".md",
				"basename": "sehnsucht.md",
				"dirname": "projekte",
				"stem": "sehnsucht",
				"path": "projekte/sehnsucht.md"
			},
			"requirePath": "projekte/sehnsucht.md",
			"path": "/projekte/sehnsucht/",
			"data": {
				"title": "Sehnsuchtslieder von der Gegenküste",
				"headImage": "sehnsuchtslieder",
				"category": "sehnsucht",
				"soundcloud": 255742653,
				"youtubeList": "PLSiRO8PBO2GweGm9qc5-jOpYGYtKkvzRP",
				"order": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "sehnsucht.sidebar.md",
				"ext": "md",
				"name": "sehnsucht.sidebar",
				"extname": ".md",
				"basename": "sehnsucht.sidebar.md",
				"dirname": "projekte",
				"stem": "sehnsucht.sidebar",
				"path": "projekte/sehnsucht.sidebar.md"
			},
			"requirePath": "projekte/sehnsucht.sidebar.md",
			"path": "/projekte/sehnsucht.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "stahlschnitt.md",
				"ext": "md",
				"name": "stahlschnitt",
				"extname": ".md",
				"basename": "stahlschnitt.md",
				"dirname": "projekte",
				"stem": "stahlschnitt",
				"path": "projekte/stahlschnitt.md"
			},
			"requirePath": "projekte/stahlschnitt.md",
			"path": "/projekte/stahlschnitt/",
			"data": {
				"title": "STAHLSCHNITT SCHWEISSER STAPELLAUF – GESCHICHTE(N) VON DER ARBEIT AUF DER AG WESER",
				"headImage": "AGWESER",
				"category": "buch",
				"order": 2
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "stahlschnitt.sidebar.md",
				"ext": "md",
				"name": "stahlschnitt.sidebar",
				"extname": ".md",
				"basename": "stahlschnitt.sidebar.md",
				"dirname": "projekte",
				"stem": "stahlschnitt.sidebar",
				"path": "projekte/stahlschnitt.sidebar.md"
			},
			"requirePath": "projekte/stahlschnitt.sidebar.md",
			"path": "/projekte/stahlschnitt.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "theater.md",
				"ext": "md",
				"name": "theater",
				"extname": ".md",
				"basename": "theater.md",
				"dirname": "projekte",
				"stem": "theater",
				"path": "projekte/theater.md"
			},
			"requirePath": "projekte/theater.md",
			"path": "/projekte/theater/",
			"data": {
				"title": "Golden City Saga – Abstruses Musiktheater",
				"headImage": "theater",
				"category": "musiktheater",
				"order": 6
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "theater.sidebar.md",
				"ext": "md",
				"name": "theater.sidebar",
				"extname": ".md",
				"basename": "theater.sidebar.md",
				"dirname": "projekte",
				"stem": "theater.sidebar",
				"path": "projekte/theater.sidebar.md"
			},
			"requirePath": "projekte/theater.sidebar.md",
			"path": "/projekte/theater.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "traumweltstadt.md",
				"ext": "md",
				"name": "traumweltstadt",
				"extname": ".md",
				"basename": "traumweltstadt.md",
				"dirname": "projekte",
				"stem": "traumweltstadt",
				"path": "projekte/traumweltstadt.md"
			},
			"requirePath": "projekte/traumweltstadt.md",
			"path": "/projekte/traumweltstadt/",
			"data": {
				"title": "TraumWeltStadt",
				"headImage": "traumweltstadt",
				"category": "quarntaene",
				"order": 1
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projekte",
				"base": "traumweltstadt.sidebar.md",
				"ext": "md",
				"name": "traumweltstadt.sidebar",
				"extname": ".md",
				"basename": "traumweltstadt.sidebar.md",
				"dirname": "projekte",
				"stem": "traumweltstadt.sidebar",
				"path": "projekte/traumweltstadt.sidebar.md"
			},
			"requirePath": "projekte/traumweltstadt.sidebar.md",
			"path": "/projekte/traumweltstadt.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "satzung.md",
				"ext": "md",
				"name": "satzung",
				"extname": ".md",
				"basename": "satzung.md",
				"dirname": "",
				"stem": "satzung",
				"path": "satzung.md"
			},
			"requirePath": "satzung.md",
			"path": "/satzung/",
			"data": {
				"title": "GOLDENE STADT E.V.",
				"headImage": "satzung"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "satzung.sidebar.md",
				"ext": "md",
				"name": "satzung.sidebar",
				"extname": ".md",
				"basename": "satzung.sidebar.md",
				"dirname": "",
				"stem": "satzung.sidebar",
				"path": "satzung.sidebar.md"
			},
			"requirePath": "satzung.sidebar.md",
			"path": "/satzung.sidebar/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tickets.md",
				"ext": "md",
				"name": "tickets",
				"extname": ".md",
				"basename": "tickets.md",
				"dirname": "",
				"stem": "tickets",
				"path": "tickets.md"
			},
			"requirePath": "tickets.md",
			"path": "/tickets/",
			"data": {
				"title": "Hol dir die Golden City App",
				"headImage": "gcapp"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tickets.sidebar.md",
				"ext": "md",
				"name": "tickets.sidebar",
				"extname": ".md",
				"basename": "tickets.sidebar.md",
				"dirname": "",
				"stem": "tickets.sidebar",
				"path": "tickets.sidebar.md"
			},
			"requirePath": "tickets.sidebar.md",
			"path": "/tickets.sidebar/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 388
// module chunks = 0